export enum ActivityLogActionsType {
    Add = 'Add',
    Edit = 'Edit',
    Delete = 'Delete',
    Download = 'Download'
}
